import React from "react";
import NewsList from "./NewsList";
import PropTypes from "prop-types";
import AppCard from "@crema/core/AppCard";
const LatestNews = (props) => {
    const { data } = props;
    return (
        <AppCard
            sxStyle={{ height: 1 }}
            contentStyle={{
                p: 0,
                "&:last-of-type": {
                    pb: "0 !important",
                },
            }}
            title={"Latest News"}
            action={"View All"}
            actionHref={"/news"}
        >
            <NewsList data={data} />
        </AppCard>
    );
};

export default LatestNews;

LatestNews.defaultProps = {
    data: [],
};

LatestNews.propTypes = {
    data: PropTypes.array,
};
